import type { SVGProps } from 'react';

/** Denmark — red field with a white Nordic cross. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const DkFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#C8102E" />
        <rect y="12" width="60" height="6" fill="#fff" />
        <rect x="12" width="6" height="30" fill="#fff" />
    </svg>
);
